import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Customer } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class CustomerService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getCustomer(
    id,
    schema = { id: null, firstName: null, lastName: null }
  ): Promise<Customer | Partial<Customer>> {
    return new Customer(await this.core.services.customer.getById(id, schema))
  }

  async getCustomers(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
      filters: {},
    },
    schema: any = { id: null }
  ): Promise<{
    items: Customer[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.customer.getList(parameters, schema)
  }

  createCustomer(
    customer: Customer | Partial<Customer>,
    schema: Customer | Partial<Customer>
  ): Promise<Customer | Partial<Customer>> {
    return this.core.services.customer.create(customer, schema)
  }

  updateCustomer(
    customer: Customer | Partial<Customer>,
    schema: Customer | Partial<Customer>
  ): Promise<Customer | Partial<Customer>> {
    return this.core.services.customer.update(customer, schema)
  }

  deleteCustomer(customer: Partial<Customer>): Promise<Customer> {
    return this.core.services.customer.delete(customer)
  }
}
